import { illustrationA11y, lineStyle } from './static-art';

export function OfferACauseIllustration(props: { className?: string; label?: string; ink?: string; heart?: string }) {
	const line = lineStyle(props.ink, 1.5);
	return (
		<svg
			width="365.741"
			height="339.555"
			viewBox="0 0 365.741 339.555"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M83.8999 214.417C94.4257 204.091 113.041 189.596 135.479 189.09C170.021 188.305 176.968 194.992 202.862 201.505C220.885 206.038 235.186 204.833 238.036 210.985C250.18 237.229 174.703 219.845 174.703 219.845"
				{...line}
			/>
			<path
				d="M239.477 214.23C239.477 214.23 297.002 196.661 303.713 201.601C315.932 210.596 291.495 223.293 226.929 246.677C183.633 262.356 152.091 247.764 141.584 241.587C139.326 240.26 136.437 240.788 134.794 242.825L126.765 252.761"
				{...line}
			/>
			<path
				d="M135.479 189.086L149.49 75.6437C150.072 71.1497 154.087 67.904 158.612 68.2749L270.628 77.3949C275.41 77.7873 278.918 82.053 278.375 86.811L264.638 207.03"
				{...line}
			/>
			<path d="M265.713 197.589C264.888 197.839 296.412 186.811 299.134 200.714" {...line} />
			<path d="M266.81 188.006C266.021 188.248 289.937 182.549 294.237 194.875" {...line} />
			<path
				d="M244.888 103.989C229.601 92.4432 214.135 106.339 208.788 112.064C207.692 113.241 205.845 113.301 204.667 112.21C189.026 97.7576 175.932 101.503 169.425 105.105C166.11 106.938 163.61 109.909 162.285 113.455C156.81 128.139 168.643 145.444 180.933 158.384L188.483 166.142C195.316 172.209 202.295 177.284 205.145 179.303C206.153 180.016 207.496 180.02 208.513 179.317C245.045 154.069 265.371 119.461 244.884 103.989H244.888Z"
				fill={props.heart ?? 'white'}
				fillOpacity="0.75"
			/>
			<path d="M132.264 44.1377V56.9136" {...line} />
			<path d="M132.263 64.802V77.5814" {...line} />
			<path d="M148.463 60.7247H135.669" {...line} />
			<path d="M128.589 60.7193H115.792" {...line} />
			<path d="M296.985 134.347V147.126" {...line} />
			<path d="M296.987 155.019V167.798" {...line} />
			<path d="M313.188 150.934H300.39" {...line} />
			<path d="M293.31 150.936H280.516" {...line} />
			<path
				d="M54.039 225.693L70.0188 208.901C72.0261 206.818 75.3228 206.697 77.4836 208.623L140.267 264.634C142.574 266.692 142.674 270.262 140.488 272.445L125.009 288.299C123.008 290.296 119.798 290.407 117.665 288.552L54.3819 233.483C52.0603 231.464 51.9067 227.915 54.0426 225.7L54.039 225.693Z"
				{...line}
			/>
		</svg>
	);
}
